import React from 'react';

const BaseIcon = () => {
  return (
    <svg className="icon" width="16px" height="16.00px" viewBox="0 0 1024 1024" version="1.1"
         xmlns="http://www.w3.org/2000/svg">
      <path fill="#333333"
            d="M288 736h128v-128H288v128z m-32-192h192a32 32 0 0 1 32 32v192a32 32 0 0 1-32 32H256a32 32 0 0 1-32-32v-192a32 32 0 0 1 32-32z m352 192h128v-128h-128v128z m-32-192h192a32 32 0 0 1 32 32v192a32 32 0 0 1-32 32h-192a32 32 0 0 1-32-32v-192a32 32 0 0 1 32-32z m32-256v128h128V288h-128z m-32-64h192a32 32 0 0 1 32 32v192a32 32 0 0 1-32 32h-192a32 32 0 0 1-32-32V256a32 32 0 0 1 32-32z m-288 192h128V288H288v128zM256 224h192a32 32 0 0 1 32 32v192a32 32 0 0 1-32 32H256a32 32 0 0 1-32-32V256a32 32 0 0 1 32-32z"/>
    </svg>
  );
};

export default BaseIcon;